export default {
  // 搜索框
  keywordPlaceholder: '请输入关键字',
  alarmTypePlaceholder: '请选择告警类型',
  startTimePlaceholder: '开始时间',
  endTimePlaceholder: '结束时间',

  // 按钮
  query: '查询',
  table: '表格',
  card: '卡片',

  // 告警类型选项
  normal: '正常',
  falseAlarm: '误报',

  // 表格列标题
  alarmType: '告警类型',
  alarmTime: '告警时间',
  alarmImage: '告警图片',
  alarmVideo: '告警视频',
  operation: '操作',

  // 卡片标签
  alarmTypeLabel: '告警类型：',
  alarmTimeLabel: '告警时间：',
  alarmImageLabel: '告警图片：',

  // 空状态
  noAlarmData: '暂无告警数据',

  // 视频相关
  alarmVideoTitle: '告警视频',
  screenshotFileName: '截图',

  // 提示信息
  markAsFalseAlarmTitle: '是否标记该图片误报',
  markSuccess: '标记成功',
  executeSuccess: '执行成功',

  map: {
    currentWaypoint: '当前航点：',
    waypointSegment: '航点段',
    algorithmName: '算法名称',
    status: '状态',
    enabled: '已启用',
    disabled: '已停用',
    view: '查看',
    aiCompareVideo: 'AI比对视频',
    watermarkDrone: '飞机',
    watermarkAlgorithm: '算法',
    loading: '加载中',
    fullscreen: '全屏',
    streamQuality: {
      auto: '自适应',
      smooth: '流畅',
      standard: '标准',
      hd: '高清',
      uhd: '超清',
    },
  },

  // 算法项目管理页面
  project: {
    projectArea: '项目区域',
    pleaseSelectMenu: '请选择上级菜单',
    configureAlgorithmLibrary: '配置算法库',
    addProjectAlgorithmBinding: '新增项目与算法的绑定',
    modelSelection: '模型选择',
    unselectedModels: '未选模型',
    selectedModels: '已选模型',
    cancel: '取消',
    confirm: '确定',
    projectName: '项目名称',
    bindingCode: '绑定码',
    projectDescription: '项目描述',
    createTime: '创建时间',
    operation: '操作',
    addSuccess: '新增成功',
    modifySuccess: '修改成功',
  },
}